export const mapArrayOfStrings = function(arrayOfStrings) {
  return arrayOfStrings.map((name, index) => {
    const response = {}
    response.id = index + 1
    response.title = name
    response.show = true
    return response
  })
}
